export default __webpack_public_path__ + "static/ENG_Step_3-987212a0aee2daf4ac7ed4f399b30e8c.svg";